enum SimType {
  UNSET_SIM_TYPE = 'UNSET_SIM_TYPE',
  SIM = 'SIM',
  ESIM = 'ESIM',
}

export { SimType as SimsSimType };
